<template>
<v-row>
  <v-col cols="12" sm="6" md="5" offset-md="2" class="mt-16">
    <v-card class="pa-10 mt-10">
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
    align="center"
  >
    <h3>Login</h3>
    <v-text-field
      v-model="email"
      :rules="emailRules"
      label="E-mail"
      placeholder="E-mail"
      required
    ></v-text-field>
    <v-text-field
      v-model="password"
      label="Password"
      :rules="nameRules"
      type="password"
      placeholder="Password"
      required
    ></v-text-field>
    <v-btn
      :disabled="!valid"
      color="success"
      class="mr-4"
      @click.prevent="validate"
    >
      Sign In
    </v-btn>
  </v-form>
    <div class="red text--darken-1 mt-3" v-if="errors.email">
      {{ errors.email[0]}}
    </div>
    </v-card>
  </v-col>
</v-row>
</template>

<script>
import Api from '../apis/Api.js';
  export default {
    data: () => ({
      valid: true,
      password: '',
      nameRules: [
        v => !!v || 'Password is required',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      select: null,
      items: [
        'Item 1',
        'Item 2',
        'Item 3',
        'Item 4',
      ],
      checkbox: false,
      errors: []
    }),

    methods: {
      validate () {
        if(this.$refs.form.validate())
        {
          Api().post('/login',{email : this.email,password: this.password})
             .then(response => {
              localStorage.setItem("token",response.data);
              console.log(response);
              this.$router.push('/home');
             })
             .catch(error => {
               if(error.response.status === 422){
                 this.errors = error.response.data.errors;
               }
             })
            
        }
       
      },
    },
  }
</script>